// extracted by mini-css-extract-plugin
module.exports = {"container_grid":"ordemcarregamento_container_grid__2VEKF","filtros":"ordemcarregamento_filtros__6i3RS","coletas":"ordemcarregamento_coletas__3_x90"};